exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.plans[data-v-453c0c08]{\n    border-top: 4px solid #eabd75;\n}\n.header-card-b[data-v-453c0c08]{\n    border: 4px solid #eabd75;\n}\n.back[data-v-453c0c08]{\n    z-index: 0;\n}\n", ""]);

// exports
